import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "simple-filters" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = {
  key: 0,
  id: "event-filters",
  class: "filter-section"
}
const _hoisted_4 = { class: "filter-section__filters" }

import { ref } from 'vue';
import DropdownFilter from '@/components/filter/DropdownFilter.vue';
import IntervalFilter from '@/components/filter/IntervalFilter.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleFilter',
  setup(__props) {

const showEventFilters = ref(true);

const toggleEventFilters = () => {
    showEventFilters.value = !showEventFilters.value;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "simple-filters__button simple-filters__button--white-line button button--clear",
      "aria-expanded": showEventFilters.value,
      "aria-controls": "event-filters",
      onClick: toggleEventFilters
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "filter-heading filter-heading--simple" }, "Händelser", -1 /* HOISTED */)),
      _createElementVNode("span", {
        class: _normalizeClass(["icon", { 'icon--minus': showEventFilters.value, 'icon--plus': !showEventFilters.value }])
      }, null, 2 /* CLASS */)
    ], 8 /* PROPS */, _hoisted_2),
    (showEventFilters.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(DropdownFilter, {
              dataKey: ['name','alternateNames'],
              placeholder: "Välj namn",
              title: "Namn"
            }),
            _createVNode(DropdownFilter, {
              dataKey: "type",
              placeholder: "Välj typ",
              title: "Typ"
            }),
            _createVNode(IntervalFilter, {
              dataKey: "launchDate",
              title: "Sjösatt/Infört i flottan"
            }),
            _createVNode(IntervalFilter, {
              dataKey: "displacement",
              title: "Ton"
            })
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})